<script lang="ts" setup>
import Header from './parts/Header.vue';
import Footer from './parts/Footer.vue';

import { ref, onMounted, onBeforeMount } from 'vue';

import axiosApiClient from '@/axios';

interface Configuration {
    key: string;
    value: string;
}

const configurations = ref<Configuration[]>([]);
const logo = ref<string>('');
const fetchGeneralConfigs = async () => {
    try {
        const response = await axiosApiClient.get('/api/configurations/corp/info');
        configurations.value = response.data;
        localStorage.setItem('corp', JSON.stringify({
            name: configurations.value.find((config: any) => config.key === 'corp_name')?.value || '',
            address: configurations.value.find((config: any) => config.key === 'corp_address')?.value || '',
            phone: configurations.value.find((config: any) => config.key === 'corp_phone')?.value || '',
            mobile: configurations.value.find((config: any) => config.key === 'corp_mobile')?.value || '',
            email: configurations.value.find((config: any) => config.key === 'corp_email')?.value || '',
            description: configurations.value.find((config: any) => config.key === 'corp_description')?.value || '',
            logo: configurations.value.find((config: any) => config.key === 'corp_logo')?.value || '',
        }));
        logo.value = configurations.value.find((config: any) => config.key === 'corp_logo')?.value || '';
    } catch (error) {
        console.error('Error fetching configurations:', error);
    }
};
onMounted(async () => {
    await fetchGeneralConfigs();
});
onBeforeMount(async () => {
    await fetchGeneralConfigs();
    setTimeout(() => {
        document.title = configurations.value.find((config: any) => config.key === 'corp_name')?.value || import.meta.env.VITE_META_COPYRIGHT;
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute('content', configurations.value.find((config: any) => config.key === 'meta_description')?.value || import.meta.env.VITE_META_DESCRIPTION);
        }
        const metaKeywords = document.querySelector('meta[name="keywords"]');
        if (metaKeywords) {
            metaKeywords.setAttribute('content', configurations.value.find((config: any) => config.key === 'meta_keywords')?.value || import.meta.env.VITE_META_KEYWORDS);
        }
        const metaAuthor = document.querySelector('meta[name="author"]');
        if (metaAuthor) {
            metaAuthor.setAttribute('content', configurations.value.find((config: any) => config.key === 'meta_author')?.value || import.meta.env.VITE_META_AUTHOR);
        }
    }, 300);
});
</script>
<template>
    <Header :logo="logo" />
    <div class="main-content">
        <slot></slot>
    </div>
    <Footer :mobile="configurations.find(c => c.key == 'corp_mobile')?.value || ''"
        :phone="configurations.find(c => c.key == 'corp_phone')?.value || ''"
        :address="configurations.find(c => c.key == 'corp_address')?.value || ''"
        :instagram="configurations.find(c => c.key == 'social_instagram')?.value || ''"
        :youtube="configurations.find(c => c.key == 'social_youtube')?.value || ''"
        :facebook="configurations.find(c => c.key == 'social_facebook')?.value || ''"
        :linkedin="configurations.find(c => c.key == 'social_linkedin')?.value || ''"
        :twitter="configurations.find(c => c.key == 'social_twitter')?.value || ''"
        :whatsapp="configurations.find(c => c.key == 'social_whatsapp')?.value || ''" />
</template>


<style lang="scss" scoped>
.main-content {
    min-height: 70vh;
    color: black;
}
</style>